import { useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

interface LinkEmailDialogProps {
  open: boolean;
  emails: { accountId: string; messageId: string }[];
  onClose: () => void;
  onSubmit: (link: { accountId: string; messageId: string }) => void;
  onUnlink: (link: { accountId: string; messageId: string }) => void;
}

export function LinkEmailDialog({ open, emails, onClose, onSubmit, onUnlink }: LinkEmailDialogProps) {
  const [accountId, setAccountId] = useState('');
  const [messageId, setMessageId] = useState('');

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md space-y-4">
        <DialogHeader>
          <DialogTitle>Link Email</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <div>
            <Label>Account ID</Label>
            <Input value={accountId} onChange={(event) => setAccountId(event.target.value)} />
          </div>
          <div>
            <Label>Message ID</Label>
            <Input value={messageId} onChange={(event) => setMessageId(event.target.value)} />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Linked Emails</Label>
          <div className="space-y-1 rounded-2xl border border-border/60 p-2 text-xs">
            {emails.length === 0 ? (
              <p className="text-muted-foreground">No linked emails.</p>
            ) : (
              emails.map((link) => (
                <div key={`${link.accountId}-${link.messageId}`} className="flex items-center justify-between">
                  <span>
                    {link.accountId} — {link.messageId}
                  </span>
                  <Button size="sm" variant="ghost" onClick={() => onUnlink(link)}>
                    Remove
                  </Button>
                </div>
              ))
            )}
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (!accountId.trim() || !messageId.trim()) {
                return;
              }
              onSubmit({ accountId: accountId.trim(), messageId: messageId.trim() });
              setAccountId('');
              setMessageId('');
            }}
          >
            Link
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
